export default __webpack_public_path__ + "static/blob4-43b6c0553c3441eb948721372b15ed6a.svg";